import { AddressPrediction, AddressDetails } from 'types';
import { AddressLookupActions, TYPES } from './actions';

interface AddressLookupReducerState {
  isLoading: boolean;
  error?: string;
  addressResults: AddressPrediction[];
  details?: AddressDetails;
}

const initialState: AddressLookupReducerState = {
  isLoading: false,
  error: '',
  addressResults: [],
};

export const addressLookupReducer = (state = initialState, action: AddressLookupActions): AddressLookupReducerState => {
  switch (action.type) {
    case TYPES.LOOKUP:
      return {
        ...state,
        isLoading: true,
        error: '',
      };

    case TYPES.LOOKUP_SUCCESS:
      return {
        // ...state,
        isLoading: false,
        error: '',
        addressResults: action.payload.addressResults,
      };

    case TYPES.LOOKUP_FAILURE:
      return {
        // ...state,
        isLoading: false,
        addressResults: [],
        error: action.payload.error,
      };

    case TYPES.DETAILS:
      return {
        ...state,
        isLoading: true,
        error: '',
      };

    case TYPES.DETAILS_SUCCESS:
      return {
        // ...state,
        isLoading: false,
        error: '',
        addressResults: [],
        details: action.payload.details,
      };

    case TYPES.DETAILS_FAILURE:
      return {
        // ...state,
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};
